<h1 class="h3 mb-2 text-gray-800">Contenidos</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Lista de Contenidos</h6>
    </div>
    <div class="card-body">
        <div *ngIf="contenidos.length==0">
            Necesita insertar un contenido
        </div>
        <div *ngIf="contenidos.length > 0" class="table-responsive">
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Llave</th>
                        <th>Valor</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let contenido of contenidos">
                        <td>{{contenido.id}}</td>
                        <td>{{contenido.key}}</td>
                        <td><img style="height: 50px" [src]="getImageUrl(contenido)"/></td>
                        <td><a [routerLink]="[ '/fotos/', contenido.key ]" class="btn btn-primary">Editar</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>